export default "__VITE_ASSET__10176fe2__"